import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

const Profile = lazy(() => import('../modules/UserProfile'))
const Referral = lazy(() => import('../modules/Affiliate'))

export const profileRoutes = [
  <Route key='profile' path='/profile' element={<Profile />} />,
  <Route key='referral' path='/profile/referral' element={<Referral />} />
]
